enum GroupMetricsType {
  CumulativeSavingsAnnualized = 'CUMULATIVE_SAVINGS_ANNUALIZED',
  AverageSavingsPerMember = 'AVERAGE_SAVINGS_PER_MEMBER',
  EstimatedGroupShareout = 'ESTIMATED_GROUP_SHAREOUT',
}

export default GroupMetricsType;
